import React, { useEffect } from 'react';
import { useApplicationState } from 'hooks/applicationState-Context';
import appleStore from 'assets/images/landing/apple_store.svg';
import androidStore from 'assets/images/landing/android_store.svg';
import qrCode from 'assets/images/landing/myrac_qrcode.svg';
import PageTitle from 'shared/components/PageTitle/PageTitle';
import useViewport from 'utils/useViewportHelper';

const MemberSavings = () => {
  const { isMobile } = useViewport();
  const { setPageLoading } = useApplicationState();

  useEffect(() => {
    setPageLoading(false);
  }, []);

  return (
    <>
      <PageTitle text="Member savings" />
      <div className="card flex-row p-3">
        {!isMobile && (
          <a href="https://www.rac.co.uk/app" rel="noopener noreferrer">
            <img src={qrCode} className="w-100 card-img-left example-card-img-responsive" alt="app" />
          </a>
        )}
        <div className={`card-body ${isMobile ? 'text-center p-3' : 'p-5'}`}>
          <div className="h1">Get your rewards in the myRAC app</div>
          <p>With the RAC you get access to £200 worth of savings on things like tyres, fuel and more. Plus enjoy exclusive discounts on parking, travel, and brands you know and love.</p>
          {isMobile && (
            <div>
              <a href="https://apps.apple.com/gb/app/myrac/id350330435" rel="noopener noreferrer">
                <img src={appleStore} className="w-50 px-2" alt="apple store" />
              </a>
              <a href="https://play.google.com/store/apps/details?id=uk.co.rac.roadside" rel="noopener noreferrer">
                <img src={androidStore} className="w-50 px-2" alt="android store" />
              </a>
              <div className="pt-4">
                Already downloaded? <a href="https://www.rac.co.uk/app" rel="noopener noreferrer">Open the app</a>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default MemberSavings;
